module.exports = __webpack_public_path__ + "static/flasche-tofi-medium-6c88ef053bb9ba1e1b25ee8444a6c675.png";